import api from "./api";

const teacherSubjectService = {
  // ==================== TEACHER-SUBJECT ASSIGNMENT ====================
  
  // Assign a teacher to a subject
  assignTeacherToSubject: (data) => 
    api.post("/teacher-subjects", data),

  // Get all teacher-subject assignments with filters
  getTeacherSubjects: (params) => 
    api.get("/teacher-subjects", { params }),

  // Get specific assignment details
  getTeacherSubjectById: (id) => 
    api.get(`/teacher-subjects/${id}`),

  // Update teacher-subject assignment
  updateTeacherSubject: (id, data) => 
    api.patch(`/teacher-subjects/${id}`, data),

  // Delete teacher-subject assignment
  deleteTeacherSubject: (id) => 
    api.delete(`/teacher-subjects/${id}`),

  // Get all subjects assigned to a specific teacher
  // Backend route: GET /api/teachers/:teacherId/subjects
  getSubjectsByTeacher: (teacherId) => 
    api.get(`/teachers/${teacherId}/subjects`),

  // Get all teachers assigned to a specific subject
  // Backend route: GET /api/teacher-subjects/subjects/:subjectId/teachers?classId=...
  // classId optional: when provided, also includes teachers from ClassSubject.preferredTeacherId
  getTeachersBySubject: (subjectId, classId = null) =>
    api.get(`/teacher-subjects/subjects/${subjectId}/teachers`, {
      params: classId ? { classId } : {},
    }),

  // ==================== TEACHER AVAILABILITY ====================
  
  // Set teacher availability (unavailable periods)
  // Backend route: PATCH /api/teachers/:id/availability
  setTeacherAvailability: (teacherId, data) => 
    api.patch(`/teachers/${teacherId}/availability`, data),

  // Get teacher availability
  getTeacherAvailability: (teacherId) => 
    api.get(`/teachers/${teacherId}/availability`),
};

export default teacherSubjectService;
